import { render } from "./card-section.vue?vue&type=template&id=f207a4ca&ts=true"
import script from "./card-section.vue?vue&type=script&lang=ts"
export * from "./card-section.vue?vue&type=script&lang=ts"

import "./card-section.vue?vue&type=style&index=0&id=f207a4ca&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__